import {IUser} from '@app/interfaces/IUser';

// проверяет, есть ли у пользователя хотя бы одна из заданных ролей
export const hasAnyRole = (user: IUser | undefined, roles: string[]) => {
    if (!user || !user.roles) return false;

    return roles.some((role) => user.roles[role] === true);
};

// проверяет, имеет ли пользователь доступ
export const hasPermission = (user: IUser | undefined, permission: string): boolean => {
    if (!user || !user.permissions) return false;
    return user.permissions[permission] === true;
};
